import React from 'react'

import { Avatar, Box } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { HomeTab } from '../../../../components/HomeTabTitle'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'
import settingsIcon from '../../../../assets/settings.svg'
import { useHistory } from 'react-router-dom'
import { integrationKeyByType } from '../../../../types/integrationTypeUtils'
import { useStore } from '../../../../hooks/storeHook'
import { appRoutes } from '../../../../common/appRoutes'
import { AccountDeleteButton } from '../../../features/accountDeleteButton'
import clsx from 'clsx'
import { accountsLogoSwitcher } from '../../../shared/lib/accountLogoSwitcher'

export type TabTitleProps = {
  account: HomeTab
}

export const TabTitle =
  ({account}: TabTitleProps) => {
    const isMoySkladTab = account.integrationType === IntegrationType.MoySklad
    const classes = useStyles()
    const history = useHistory()
    const {setHomeNav} = useStore()

    const handleRedirectToSettingsPage = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      setHomeNav(account.integrationType, account.id)
      e.stopPropagation()

      history.push(appRoutes.Store.settings.makeUrl(
        {
          integration: integrationKeyByType[account.integrationType],
          accountId: isMoySkladTab ? 0 : account.id
        }))

    }

    return (
      <Box className={classes.wrapper}>
        {!isMoySkladTab && <AccountDeleteButton accountId={account.id} integrationType={account.integrationType}/>}
        <Avatar src={settingsIcon} alt="Настройка аккаунта" className={clsx(classes.img, classes.animated)}
                onClick={handleRedirectToSettingsPage}/>
        <span style={{lineHeight: '12px'}}>
          {account.title}
        </span>
        <Avatar
          src={accountsLogoSwitcher(account.integrationType)}
          alt={account.title}
          className={classes.img}
          variant={'square'}
        />
      </Box>
    )
  }

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: 8,
      alignItems: 'center'
    },
    img: {
      width: 12,
      height: 12,
      transition: 'transform 0.3s ease-in-out'
    },
    animated: {
      '&:hover': {
        animation: '$spin 1s linear infinite'
      }
    },
    '@keyframes spin': {
      from: {transform: 'rotate(0deg)'},
      to: {transform: 'rotate(360deg)'}
    }
  })
)